import { FC, useEffect } from "react";
import { useDropzone } from 'react-dropzone';
import { Loader } from './Loader';
import { FileUploadIcon } from '../assets/FileUploadIcon';
import { FilesIcon } from '../assets/FilesIcon';
import { ErrorIcon } from '../assets/ErrorIcon';
import { RemoveIcon } from '../assets/RemoveIcon';

const DROPZONE_OPTIONS = {
    noClick: true,
    noKeyboard: true,
    maxFiles: 5,
    accept: [".pdf", ".jpeg", ".jpg", ".png"]
}

const NoFiles: FC = () => {
    return (
        <>
            <FileUploadIcon />
            <p>No files uploaded</p>
        </>
    )
}

interface FilesProps {
    /*eslint no-empty-pattern: "off"*/
    files: File[];
    clearFile: (file: File) => void;
}

const Files: FC<FilesProps> = ({ files, clearFile }) => {
    return (
        <>
            {files.map(file => (
                <div className="dropzone__status__file" key={file.name}>
                    <FilesIcon />
                    <div className="u-m__l">
                        <div className="dropzone__status__file__name">
                            <p className="u-m__r">{file.name}</p>
                            <RemoveIcon
                                size={25}
                                className="remove-icon"
                                onClick={() => clearFile(file)}
                                role={"button"}
                                tabIndex={0}
                            />
                        </div>

                        <p className="dropzone__status__file__meta">{file.type.split('/')[1].toUpperCase()}, {(file.size / 1000000).toFixed(2)}mb</p>
                    </div>
                </div>
            ))}
        </>
    )
}

interface FileControlProps {
    uploadState: string;
    fileState: File[];
    setFileState: ([]) => void;
    setShowFileControl: (show: boolean) => void;
    maxFiles: number;
    resetAllowedMaxFiles?: () => void;
}
export const FileControl: FC<FileControlProps> = ({ uploadState, fileState, setFileState, setShowFileControl, maxFiles, resetAllowedMaxFiles }) => {
    const { fileRejections, getRootProps, getInputProps, open, acceptedFiles } = useDropzone({ ...DROPZONE_OPTIONS, maxFiles: maxFiles });
    useEffect(() => {
        setFileState(acceptedFiles); resetAllowedMaxFiles && resetAllowedMaxFiles();
    }, [acceptedFiles, resetAllowedMaxFiles])

    const clearFile = (file: File) => {
        const newFiles = acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
        acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
        setFileState(newFiles);
        if (fileState.length === 0) {
            setFileState([]);
            setShowFileControl(false);
        }
    }

    const filesStaged = fileState?.length > 0;

    const fileRejectionItems = fileRejections.map(({ errors }) => {

        return (
            errors?.length > 0 ? errors[0].message : ''
        )
    });

    return <div {...getRootProps({ className: 'dropzone u-p ' })}>
        <input className="form__input" {...getInputProps()} />

        <div className="dropzone__status">
            {uploadState === 'none' && !filesStaged && <NoFiles />}
            {uploadState === 'none' && filesStaged && <Files files={fileState} clearFile={clearFile} />}
            {uploadState === 'loading' && <Loading />}
            {(uploadState === 'error' || fileRejectionItems?.length > 0) && <Error errorMsg={fileRejectionItems} />}
        </div>

        {uploadState !== 'loading' && (
            <button className={`${filesStaged ? "btn--ghost" : "btn"} u-m__t`} onClick={open}>
                Select File
            </button>)}

    </div>
}

interface ErrorProps {
    errorMsg?: string[];
}
const Error: FC<ErrorProps> = ({ errorMsg }) => {
    return (
        <>
            <ErrorIcon height={32} />
            <p className="verification-error">Something went wrong.</p>
            {errorMsg && errorMsg.length > 0 && <p className="verification-error">{errorMsg[0]}</p>}
        </>
    );
}

const Loading: FC = () => {
    return (
        <div>
            <Loader className="loading-anchor" />
            <p>Uploading your file.</p>
        </div>
    );
}